// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";
import UndoIcon from '@mui/icons-material/Undo';


// App Imports
import Box from "@mui/material/Box";
import {deleteCdpVersion} from "../../../ContractDataPoint/ContractDataPointClient";
import {changeWorkIssuance} from "../../workIssuanceSlice";


// main function
export default function UndoOwed({ onMenuClose, rowCdpStatus, showOwed, showExpense }) {

    const selectorMaxVersionNumber = useSelector((state) => state.workSlc.value.maxVersionNumber);
    const selectorProductId = useSelector((state) => state.workSlc.value.propertyId);
    const selectorMultiSingle = useSelector((state) => state.workSlc.value.multiSingle);


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    const handleUndo = () => {
        console.log("handleUndo");
        console.log("selectorMaxVersionNumber: ", selectorMaxVersionNumber);
        console.log("selectorProductId: ", selectorProductId);
        console.log("selectorMultiSingle: ", selectorMultiSingle);
        deleteCdpVersion(selectorMaxVersionNumber, selectorProductId, selectorMultiSingle,"calc")
            .then(response => response.data)
            .then(data => {
                    console.log("deleteCdpVersion data: ", data);
                }
            )
            .then(response => {
                console.log("deleteCdpVersion response: ", response);
                dispatchData(changeWorkIssuance({owedGridRefresh: true}));
            })
            .catch(error => {
                    console.log("deleteCdpVersion error: ", error);
                }
            )
        // dispatchData(changeOwed({deferState: true, owedNewStatus: '3242'}));
        onMenuClose();
    };
    return (

        <Box>
            {(
                    rowCdpStatus !== "1"
                    // rowCdpStatus === "2339" ||  rowCdpStatus === "2040"
                    // rowCdpStatus === "2351" ||  rowCdpStatus === "2359"
                ) && showOwed === true  &&
                <MenuItem onClick={handleUndo}>
                    <ListItemIcon>
                        <UndoIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Undo</ListItemText>
                </MenuItem>
            }
        </Box>

    )

}
